import React from 'react';
import { Row, Col } from 'react-bootstrap';
export default class HeadingDivider extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(Row, null,
            React.createElement(Col, { md: 12 },
                React.createElement("h5", { style: {
                        borderBottom: "1px solid #D0D0D0",
                        lineHeight: "0.1em"
                    } },
                    React.createElement("span", { style: { backgroundColor: "#fff" } }, this.props.text)))));
    }
}
